import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;

export async function getAllRegions() {
  try {
    const response = await fetch(base + 'regions');
    return await response.json();
  } catch (error) {
    console.error('Erreur getAllRegions', error);
    throw error;
  }
}
  
export async function createRegion(regionName) {
  try {
    const authToken = localStorage.getItem("authToken"); // Récupération du token
    const response = await fetch(base + 'regions/insert', {
      method: 'POST',
      credentials: "include", // Permet d'envoyer les cookies avec chaque requête, si http-only
      headers: { 'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${authToken}` // Ajout du token dans le header => penser à modifier .htaccess de l'API pour autoriser cet en-tête
       },
      body: new URLSearchParams({ nom: regionName }),
    });
    return await response.json();
  } catch (error) {
    console.error('Erreur createRegion', error);
    throw error;
  }
}

export async function updateRegion(regionId, regionName) {
  try {
    const authToken = localStorage.getItem("authToken"); // Récupération du token
    const response = await fetch(base + 'regions/update', {
      method: 'POST',
      credentials: "include", // Permet d'envoyer les cookies avec chaque requête, si http-only
      headers: { 
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${authToken}` // Ajout du token dans le header
      },
      body: new URLSearchParams({ 
        id: regionId,
        nom: regionName 
      }),
    });
    return await response.json();
  } catch (error) {
    console.error('Erreur updateRegion', error);
    throw error;
  }
}

export async function deleteRegion(regionId) {
  try {
    const authToken = localStorage.getItem("authToken"); // Récupération du token
    const response = await fetch(base + 'regions/delete', {
      method: 'POST',
      credentials: "include", // Permet d'envoyer les cookies avec chaque requête, si http-only
      headers: { 
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${authToken}` // Ajout du token dans le header
      },
      body: new URLSearchParams({ id: regionId }),
    });
    return await response.json();
  } catch (error) {
    console.error('Erreur deleteRegion', error);
    throw error;
  }
}
  